<template>
    <v-card v-if="dialog.visible" class="alert">
        <v-alert
            :type="dialog.type"
            :title="dialog.title"
            :text="dialog.text"
            class="pb-6 pr-8 pr-xl-12"
        >
        <v-card-actions>
            <v-btn color="primary" block @click="clousePopup">
                <svg width="195" height="201" viewBox="0 0 195 201" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M57.5101 33.2141C67.1601 43.1241 76.3301 53.6041 86.6901 62.7141C91.6501 67.0741 98.7201 70.5341 104.41 61.6241C107.18 57.2741 111.37 53.8241 114.96 49.9041C115.47 49.9041 115.94 50.0441 116.4 50.0341C116.56 50.0341 116.7 49.6541 116.85 49.4441C116.12 49.7341 115.4 50.0341 114.67 50.3241C128.48 36.3641 142.29 22.4041 156.11 8.4541C156.83 7.7341 157.52 6.6641 158.39 6.4541C167.63 4.2441 180.8 -2.6259 185.35 1.0741C194.48 8.4841 187.3 19.7541 180.7 27.6641C164.97 46.4941 149.84 66.0641 132.19 82.9541C123.09 91.6641 123.08 96.0741 131.3 103.504C135.35 107.164 138.88 111.414 142.64 115.394L142.45 115.054C157.03 128.514 172.27 141.344 186 155.624C198.72 168.854 196.85 175.974 180.4 188.674L180.96 188.514C175.54 186.424 169.45 185.284 164.84 182.044C156.68 176.304 149.06 169.654 141.88 162.704C127.87 149.154 114.32 135.144 100.6 121.344C100.46 121.574 100.29 121.794 100.12 122.014C100.45 121.854 100.77 121.684 101.1 121.524C82.2601 143.224 63.4901 164.994 44.5001 186.564C40.3101 191.324 35.9901 197.354 30.5201 199.204C25.4301 200.934 15.2101 199.774 13.4501 196.524C9.84009 189.864 6.68009 178.614 9.95009 173.444C17.5901 161.374 29.1401 151.774 39.0701 141.154C39.2901 141.204 39.5401 141.264 39.7801 141.334C39.5701 141.484 39.3501 141.624 39.1401 141.774C39.2501 141.614 39.3601 141.444 39.4701 141.284C49.9801 126.494 60.4801 111.694 72.1701 95.2341C59.3801 83.1941 45.6001 70.4241 32.0701 57.3941C23.4401 49.0941 14.8501 40.7141 6.85009 31.8141C-0.64991 23.4741 -3.18991 13.8041 5.40009 4.7441C14.3101 -4.6559 21.4001 2.5941 28.3801 8.4741C37.0701 15.8041 45.8601 23.0041 54.6001 30.2541L54.4501 30.1741C53.7201 30.5541 57.3701 34.5141 57.5901 33.3441L57.5201 33.2041L57.5101 33.2141Z" fill="#fff"/>
                </svg>
            </v-btn>
        </v-card-actions>
        </v-alert>
    </v-card>
</template>

<script>
export default {
    name: 'AlertPopup',
    props: ['title', 'text', 'type'],
    data() {
        return {            
        }
    },
    computed: {
        dialog() {
            return this.$store.getters.alertApp;
        },
    },
    methods: {
        clousePopup() {
            this.dialog.visible = false;
            
            this.$store.commit('setAlertData', {
                visible: false,
                title: '',
                text: '',
                type: ''
            });
        }
    },
    watch: {
        dialog(newData) {

            if(newData.visible == true) {
                
                setTimeout(() => {
                    this.clousePopup();
                }, 8000);
            }
        }
    }
}
</script>

<style lang="stylus">
    .alert {   
        position: fixed!important;
        bottom: 10%;    
        right: 7%;
        z-index: 999999999999!important;

        @media screen and (max-width: 1400px) {
            right: 30px;
            bottom: 30px; 
        }
    }

    .v-card 
        max-width: 330px;
        z-index: 999;

        @media screen and (max-width: 2000px) {
            max-width: 260px;
        }


    .v-btn__content svg
        width: 15px
        height: 15px
    
    .v-card-actions
        position: absolute;
        top: 0;
        right: 0;

.v-alert {
    
    @media screen and (max-width: 2000px) {
        font-size: 14px;
        line-height: 1.3
    }
}    
.v-card
    position: relative;

    &:after
        color: #000;
        top: 1.5rem;
        left: 1rem;
        position: absolute;
        content: '';
        background-size: cover;
        width: 31px;
        height: 30px;
        z-index: 9999;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='201' height='193' viewBox='0 0 201 193' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M73.6403 5.2245C83.8503 2.0445 94.4703 0.274503 104.45 0.0245034C144.57 -0.955497 182.59 27.5745 195.2 65.0945C200.03 79.4745 201.44 95.1045 198.41 109.965C197.1 116.405 194.97 122.664 192.33 128.684C183.37 149.094 168.22 166.855 149.07 178.255C124.08 193.135 92.6003 196.295 64.9903 187.335C51.6203 182.995 39.4603 178.124 29.1203 168.204C19.1403 158.615 11.3003 146.575 6.22033 133.715C-0.869667 115.785 -2.07967 95.4645 3.53033 77.0145C4.64033 73.3745 5.99033 69.8245 7.35033 66.2745C9.73033 60.0545 12.1203 53.8045 15.5003 48.0745C27.5803 27.6045 51.3603 12.1745 73.6403 5.2245ZM21.1803 115.594C22.5003 124.084 25.2503 132.294 29.7603 139.594C36.6803 150.775 47.3303 159.064 59.0103 164.844C72.3003 171.424 84.3503 173.135 99.0503 173.145C112.25 173.154 125.42 168.824 136.85 162.264C139.42 160.794 141.91 159.184 144.31 157.454C159.78 146.264 171.16 129.555 175.9 111.055C180.67 92.4445 179.82 67.7445 167.65 52.1345C151.52 31.4345 127.89 20.9445 102.14 21.0745C81.7303 21.1745 60.9303 29.9745 45.9803 44.0545C41.2803 48.4845 37.3303 53.6645 33.7503 59.0345C29.9903 64.6645 26.5903 70.5845 24.3203 76.9645C22.2703 82.7145 21.1603 88.7645 20.6103 94.8345C19.9903 101.725 20.1203 108.744 21.1803 115.594ZM82.6403 99.9945C83.1303 105.604 84.4303 111.985 90.8303 113.505C94.7903 114.445 99.0903 112.955 102.11 110.225C103.38 109.075 104.49 107.674 104.95 106.024C105.31 104.744 105.26 103.385 105.22 102.055C104.6 85.3945 104.81 68.6445 104.11 52.0445C103.95 48.1445 102.78 44.3345 97.7903 43.9345C90.8003 43.3745 83.8303 46.7445 83.2703 50.8845C83.2403 51.1345 83.1803 51.3845 83.1903 51.6445C83.3003 55.2945 83.5003 58.9345 83.5203 62.5845C83.5603 75.0545 83.5403 87.5245 83.5403 99.9945H82.6403ZM105.99 144.844C107.61 142.005 107.75 138.484 106.97 135.305C106.19 132.125 104.58 129.215 102.85 126.435C101.17 123.735 98.9903 120.875 95.8403 120.435C92.0203 119.895 88.7303 123.195 86.8403 126.555C83.7503 132.045 83.2203 140.044 87.3103 145.204C89.5603 148.035 93.3703 149.624 97.0803 149.624C100.65 149.624 104.12 148.134 105.99 144.844Z' fill='%23fff'/%3e%3c/svg%3e ");
</style>